// extracted by mini-css-extract-plugin
export default {"tag":"current-filter-tag_tag__-k3r0","labelPrefix":"current-filter-tag_labelPrefix__xGf6R"};